import { render, staticRenderFns } from "./TaskNode.vue?vue&type=template&id=40d1983d&scoped=true"
import script from "./TaskNode.vue?vue&type=script&lang=js"
export * from "./TaskNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d1983d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d1983d')) {
      api.createRecord('40d1983d', component.options)
    } else {
      api.reload('40d1983d', component.options)
    }
    module.hot.accept("./TaskNode.vue?vue&type=template&id=40d1983d&scoped=true", function () {
      api.rerender('40d1983d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/nodes/TaskNode.vue"
export default component.exports